import React from 'react';
import { Redirect } from 'react-router-dom';

function Ayuda() {
    return(
        <Redirect target='_blank' to={"https://www.notion.so/Asistente-Okki-59177efb67264912a4794da38a5b9fdc"}/>
    )
}

export default Ayuda;